import type { Degree } from '../../../../../domain/Degree';
import type { Percent } from '../../../../../domain/Percent';
import type { Voltage } from '../../../../../domain/Voltage';
import type { AttentionStatusType } from '../../../../AttentionStatus';
import type { ForMessaging } from '../../../../AttentionStatusRepository';
import type { EvaluatedResult } from '../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../RulesProvider';
import type { ForEnergyConsumerEvaluation } from '../../../gridElements/energyConsumer/forEnergyConsumerEvaluation';
import { VoltageCosinePhiEvaluation } from './PropertiesEvaluations/VoltageCosinePhiEvaluation';
import { VoltageDiffNominalEvaluation } from './PropertiesEvaluations/VoltageDiffNominalEvaluation';
import { VoltageDiffTransformerEndEvaluation } from './PropertiesEvaluations/VoltageDiffTransformerEndEvaluation';
import { VoltageDiffTransformerEndPercentEvaluation } from './PropertiesEvaluations/VoltageDiffTransformerEndPercentEvaluation';
import { VoltageEvaluation } from './PropertiesEvaluations/VoltageEvaluation';

export class EnergyConsumerEvaluationEngine
  implements ForEnergyConsumerEvaluation
{
  constructor(private readonly rulesProvider: ForRuleProviding) {}

  evaluateVoltageDiffTransformerEndPercent(
    voltageDiffPercent: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Percent> {
    const evaluation = new VoltageDiffTransformerEndPercentEvaluation(
      this.rulesProvider
    ).evaluate(voltageDiffPercent);
    messenger.send(
      evaluation.status,
      this.evaluateVoltageDiffTransformerEndPercent.name
    );
    return evaluation.toEvaluatedResult();
  }

  public evaluateVoltage(
    voltage: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageEvaluation(this.rulesProvider).evaluate(
      voltage
    );
    messenger.send(evaluation.status, this.evaluateVoltage.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateVoltageCosinePhi(
    voltageCosinePhi: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Degree> {
    const evaluation = new VoltageCosinePhiEvaluation(
      this.rulesProvider
    ).evaluate(voltageCosinePhi);
    messenger.send(evaluation.status, this.evaluateVoltageCosinePhi.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateVoltageDiffNominal(
    voltageDiffNominal: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageDiffNominalEvaluation(
      this.rulesProvider
    ).evaluate(voltageDiffNominal);
    messenger.send(evaluation.status, this.evaluateVoltageDiffNominal.name);
    return evaluation.toEvaluatedResult();
  }

  evaluateVoltageDiffTransformerEnd(
    voltageDiffNominal: number,
    messenger: ForMessaging<AttentionStatusType>
  ): EvaluatedResult<Voltage> {
    const evaluation = new VoltageDiffTransformerEndEvaluation(
      this.rulesProvider
    ).evaluate(voltageDiffNominal);
    messenger.send(
      evaluation.status,
      this.evaluateVoltageDiffTransformerEnd.name
    );
    return evaluation.toEvaluatedResult();
  }
}
